import { useTranslation } from "react-i18next";

const VentureBuilder = () => {
  const { t } = useTranslation();
  return (
    <div className="container mt-5">
      <div className="row">
        <h1>{t("page.ventureBuilder.title")}</h1>
      </div>
    </div>
  );
};

export default VentureBuilder;
